import React, { memo } from 'react'
import { Text, HeadingText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { NOTIFICSTION_SETTINGS } from '../../constants/constants'

const MarketingPreferences = memo((props) => (
  <div className="privacyHub-model">
    <HeadingText
      id="marketingPrefsHeader"
      className="privacyHub-model-heading"
      size="lg"
    >
      <Message id="privacyhub.marketingpreferences.header" />
    </HeadingText>
    <Text size="lg" className="privacyHub-model-content">
      <Message
        id="privacyhub.marketingpreferences.component.desc"
        link={(innerMessage) => (
          <Link
            theme="v2"
            id="notificationSettingsLink"
            name="notification_settings"
            href={NOTIFICSTION_SETTINGS}
          >
            {innerMessage}
          </Link>
        )}
      />
    </Text>
    <Text size="lg" className="privacyHub-model-content">
      <Message id="privacyhub.marketingpreferences.component.content" />
    </Text>

    {props.content(props.keys && props.keys.marketingprefs)}
  </div>
))

MarketingPreferences.displayName = 'MarketingPreferences'

export default MarketingPreferences
